<template>
  <tab-container-icon
    :tabs="
      job && job.added_manually == 2
        ? {
            pictures: 'Foto',
            code: 'QR-Code',
            checks: 'Kontrolle',
          }
        : {
            code: 'QR-Code',
            checks: 'Kontrolle',
          }
    "
    :initial-tab="job && job.added_manually == 2 ? 'pictures' : 'code'"
    :show-nav-indices="job && job.added_manually != 2"
    class="col tab-container--vertical tab-container--steps job-report"
    :nav-class="`job-report__steps__nav mb-xl ${
      job && job.added_manually == 2 ? 'hidden' : ''
    }`"
  >
    <template slot="pictures" slot-scope="tabContainer">
      <p class="info-text">
        Für die digitale Dokumentation ein Foto von jeder Seite machen, wenn die
        Tür geschlossen ist. Foto im Hochformat.
      </p>

      <ul class="job-report__main job-report__pictures list-reset list-h mt-xl">
        <li
          v-for="(picture, index) in pictures"
          :key="index"
          class="job-report__pictures__picture"
        >
          <label
            :is="allowEdit ? 'label' : 'div'"
            class="job-report__pictures__picture__label"
          >
            <img v-if="picture.src" :src="picture.src" class="picture" />
            <spinner v-else-if="picture.loading"></spinner>
            <img v-else :src="icon('camera.svg')" />

            <div v-if="picture.label" class="btn btn-next btn-full-width">
              {{ picture.label }}
            </div>
            <div
              v-else-if="allowEdit"
              class="btn btn-secondary btn-full-width btn-icon"
              @click="removePicture(index, $event)"
              :disabled="!allowEdit"
            >
              <img :src="icon('cross.svg')" /> <span>Löschen</span>
            </div>

            <input
              v-if="allowEdit"
              type="file"
              accept="image/x-png,image/jpeg,image/jpg"
              @input="setPicture(index, $event)"
            />
          </label>
          <button
            v-if="allowEdit && picture.label && picture.src"
            @click="removePicture(index, $event)"
            class="job-report__pictures__picture__btn-remove"
          >
            <img :src="icon('trash.svg')" />
          </button>
        </li>
        <li v-if="savedPictures.length >= requiredPictures.length && allowEdit">
          <label class="job-report__pictures__picture__add">
            <img :src="icon('cross.svg')" class="icon-add mb-sm" />
            Weiteres Foto

            <input
              type="file"
              accept="image/x-png,image/jpeg,image/jpg"
              @input="addPicture"
            />
          </label>
        </li>
      </ul>

      <div class="job-report__buttons">
        <button
          class="btn btn-highlighted"
          @click="save(false, gotoPartsOverview, true)"
        >
          Abbrechen
        </button>

        <div>
          <button
            class="btn btn-back"
            @click="save(false, tabContainer.showPrev, true)"
          >
            Zurück
          </button>
          <button
            v-if="job && job.added_manually == 2"
            class="btn btn-next"
            @click="save(false, gotoPartsOverview, true)"
          >
            <!-- :disabled="savedPictures.length < requiredPictures.length" -->
            Kontrolle abschließen
          </button>
          <button
            v-else
            class="btn btn-next"
            @click="tabContainer.showNext"
          >
            <!-- :disabled="savedPictures.length < requiredPictures.length" -->
            Weiter
          </button>
        </div>
      </div>
    </template>

    <template slot="code" slot-scope="tabContainer">
      <p class="info-text">
        Wenn der QR-Code aufgeklebt ist, den Code mit der Kamera erfassen.
      </p>

      <div class="job-report__main mt-xl">
        <div class="job-report__code">
          <div class="job-report__code__preview-wrapper">
            <div
              class="job-report__code__preview"
              :class="code.code ? 'qrcode-ml' : ''"
            >
              <img v-if="!code.code" :src="icon('camera.svg')" />
              <qrcode-vue v-else :value="code.code" level="M"></qrcode-vue>

              <div v-if="code.code" class="job-report__code__ok">
                <img :src="icon('check-circle-green.svg')" />
                <img v-if="sameCode" :src="icon('check-circle-green.svg')" />
              </div>
            </div>

            <p v-if="code.code" class="text-center mb-0 mt-xs qrcode-ml">
              {{ code.code }}
            </p>

            <button
              :class="{
                'btn btn-full-width mt-mdsm': true,
                'btn-next': !code.code,
                'btn-secondary qrcode-ml': code.code ? true : false,
              }"
              @click="scanCode"
              :disabled="!allowEdit"
            >
              QR-Code {{ code && code.code ? "ersetzen" : "erfassen" }}
            </button>
          </div>
        </div>
      </div>

      <div class="job-report__buttons">
        <button class="btn btn-highlighted" @click="gotoPartsOverview">
          Abbrechen
        </button>

        <div>
          <button
            v-if="job && job.added_manually == 2"
            class="btn btn-back"
            @click="tabContainer.showPrev"
          >
            Zurück
          </button>
          <button v-else class="btn btn-back" @click="gotoPartsOverview">
            Zurück
          </button>
          <button
            class="btn btn-next"
            @click="tabContainer.showNext"
            :disabled="false"
          >
            Weiter
          </button>
        </div>
      </div>
    </template>

    <template slot="checks" slot-scope="tabContainer">
      <div class="job-report__main job-report__checks">
        <div class="job-report__checks__door">
          <div class="job-report__checks__door__img">
            <img src="/img/job/door-transparent.png" />
            <button
              v-for="(area, index) in areas"
              :key="area.id"
              :style="config.jobs.report.checks.doorAreas[area.id]"
              :class="{
                active: checksAreaIndex == index,
                done:
                  areaChecksDone[area.id] === true && areaImageDone[area.id],
              }"
              @click="checksAreaIndex = index"
            >
              <img
                v-if="
                  areaChecksDone[area.id] === true && areaImageDone[area.id]
                "
                :src="
                  icon(
                    checksAreaIndex == index
                      ? 'check-circle-white.svg'
                      : 'check-circle-gray.svg'
                  )
                "
              />
              <img
                v-else-if="areaChecksDone[area.id] === 1"
                :src="icon('warning-white.svg')"
              />
              <img
                v-else-if="config.jobs.report.checks.doorAreas[area.id].icon"
                :src="icon(config.jobs.report.checks.doorAreas[area.id].icon)"
                :width="config.jobs.report.checks.doorAreas[area.id].iconWidth"
              />
              <span v-else>{{ index + 1 }}</span>
            </button>
          </div>
        </div>

        <div class="job-report__checks__checks pl-lg">
          <div class="job-report__checks__title mb-2">
            <strong
              >{{ checksAreaIndex + 1 }}.
              {{ __(`jobs.common.parts.areas.door.${checksArea.key}`) }}</strong
            >
          </div>
          <collapsible
            :class="'checklist-collapsible'"
            class-head="container-fluid"
            class-head-inner="row m-0"
            :close-on-head-click="true"
          >
            <template slot="head">
              <div class="title d-flex w-100">
                <img
                  :src="
                    icon(
                      areaChecksDone[checksArea.id]
                        ? 'checkbox-checked-green.svg'
                        : 'checkbox-unchecked.svg'
                    )
                  "
                />
                <span class="ml-3">Checks</span>
              </div>
            </template>
            <template slot="body">
              <ul class="job-report__checks__operations list-reset list-h">
                <li
                  v-for="operationType in app.options.ChecklistCheck
                    .OPERATION_TYPES"
                  :key="operationType.id"
                  class="job-report__checks__operation"
                >
                  <img
                    :src="
                      icon(
                        config.jobs.report.checks.operationIcons[
                          operationType.id
                        ]
                      )
                    "
                  />

                  <popover
                    :key="`popover-operation-name-${operationType.id}`"
                    target="img"
                    relative-to="$parent"
                    position="top"
                    :show-on-mounted="false"
                    :show-on-updated="false"
                    :toggle-on="['click', 'mouseenter', 'mouseleave']"
                    :hide-on-outside-click="true"
                  >
                    <div v-html="operationType.name"></div>
                  </popover>
                </li>
              </ul>

              <div
                v-for="check in areaChecks"
                :key="check.id"
                class="job-report__checks__operations job-report__checks__check"
              >
                <ul class="list-reset list-h">
                  <li
                    v-for="operationType in app.options.ChecklistCheck
                      .OPERATION_TYPES"
                    :key="`${check.id}_${operationType.id}`"
                    class="job-report__checks__operation"
                  >
                    <template
                      v-if="
                        check.operations[operationType.id] &&
                        check.operations[operationType.id] == '1'
                      "
                    >
                      <img
                        :src="
                          icon(
                            report.checks[check.id][operationType.id] == 1
                              ? 'checkbox-checked.svg'
                              : 'checkbox-unchecked.svg'
                          )
                        "
                        @click="toggleCheckOperation(check, operationType.id)"
                      />
                    </template>
                  </li>
                  <li class="job-report__checks__check__status">
                    <img
                      v-if="ifCheckDone(check, true)"
                      :src="icon('check-circle-green.svg')"
                    />

                    <button
                      v-else-if="allowEdit || ifCheckHasMessage(check)"
                      class="btn-plain"
                      @click="createMessage(check, $event)"
                    >
                      <img
                        :src="
                          icon(
                            ifCheckHasMessage(check)
                              ? 'warning-important.svg'
                              : 'note.svg'
                          )
                        "
                      />
                    </button>
                  </li>
                  <li class="job-report__checks__check__title">
                    {{ check.title }}

                    <template v-if="check.description">
                      <img
                        :src="icon('info.svg')"
                        class="job-report__checks__check__description ml-sm"
                      />

                      <popover
                        :key="`popover-check-description-${check.id}`"
                        target=".job-report__checks__check__description"
                        relative-to="$parent"
                        position="top-end"
                        :show-on-mounted="false"
                        :show-on-updated="false"
                        :toggle-on="['click', 'mouseenter', 'mouseleave']"
                        :hide-on-outside-click="true"
                        max-width="400px"
                      >
                        <div v-html="check.description"></div>
                      </popover>
                    </template>
                  </li>
                </ul>
              </div>
              <div class="job-report__checks__buttons mt-xxl mb-3">
                <button
                  class="btn btn-primary"
                  @click="checkAll"
                  :disabled="!allowEdit"
                >
                  Alles auswählen
                </button>
              </div>
            </template>
          </collapsible>

          <collapsible
            :class="'checklist-collapsible'"
            class-head="container-fluid"
            class-head-inner="row m-0"
          >
            <template slot="head">
              <div class="title d-flex w-100">
                <img
                  :src="
                    icon(
                      areaImageDone[checksArea.id]
                        ? 'checkbox-checked-green.svg'
                        : 'checkbox-unchecked.svg'
                    )
                  "
                />
                <span class="ml-3"> Fotodokumentation</span>
              </div>
            </template>
            <template slot="body">
              <ul
                class="
                  job-report__main job-report__pictures
                  list-reset list-h
                  mt-xl
                "
              >
                <li
                  v-for="(picture, index) in picturesArea"
                  :key="index"
                  class="job-report__pictures__picture"
                >
                  <label
                    :is="allowEdit ? 'label' : 'div'"
                    class="job-report__pictures__picture__label"
                  >
                    <img
                      v-if="picture.src"
                      :src="picture.src"
                      class="picture"
                    />
                    <spinner v-else-if="picture.loading"></spinner>
                    <img v-else :src="icon('camera.svg')" />

                    <div
                      v-if="picture.label"
                      class="btn btn-next btn-full-width"
                    >
                      {{ picture.label }}
                    </div>
                    <div v-else-if="allowEdit">
                      <div
                        v-if="
                          index + 1 <=
                          reportData.requiredPicture[areas[checksAreaIndex].key]
                            .length
                        "
                        class="btn btn-next btn-full-width"
                      >
                        {{
                          reportData.requiredPicture[
                            areas[checksAreaIndex].key
                          ][index]
                            ? reportData.requiredPicture[
                                areas[checksAreaIndex].key
                              ][index].label
                            : ""
                        }}
                      </div>
                      <div
                        v-else
                        :class="'btn btn-secondary btn-full-width btn-icon'"
                        @click="removeImage(index, $event)"
                        :disabled="!allowEdit"
                      >
                        <img :src="icon('cross.svg')" />
                        <span> Löschen</span>
                      </div>
                    </div>

                    <input
                      v-if="allowEdit"
                      type="file"
                      accept="image/x-png,image/jpeg,image/jpg"
                      @input="setImage(index, $event)"
                    />
                  </label>
                  <button
                    v-if="allowEdit && picture.label && picture.src"
                    @click="removeImage(index, $event)"
                    class="job-report__pictures__picture__btn-remove"
                  >
                    <img :src="icon('trash.svg')" />
                  </button>
                </li>
                <li>
                  <label class="job-report__pictures__picture__add">
                    <img :src="icon('cross.svg')" class="icon-add mb-sm" />
                    Weiteres Foto
                    <input
                      type="file"
                      accept="image/x-png,image/jpeg,image/jpg"
                      @input="addImages"
                    />
                  </label>
                </li>
              </ul>
            </template>
          </collapsible>
        </div>
      </div>

      <div class="job-report__buttons">
        <button class="btn btn-highlighted" @click="gotoPartsOverview">
          Abbrechen
        </button>

        <div>
          <button class="btn btn-back" @click="tabContainer.showPrev">
            Zurück
          </button>
          <button
            v-if="job.status == app.options.Job.STATUS.inprocess"
            class="btn btn-next"
            @click="save(false, gotoPartsOverview, true)"
          >
            <!-- :disabled="!checksDone || !checkImage" -->
            Kontrolle abschließen
          </button>
        </div>
      </div>
    </template>
  </tab-container-icon>
</template>

<script>
import JobViewBase from "./ViewBase";
import LoadsImages from "../../mixins/LoadsImages";
import QrScannerWindow from "../../windows/QrScanner";
import JobTechnicianMessageWindow from "../../windows/JobTechnicianMessage";
import QrcodeVue from "qrcode.vue";

export default {
  extends: JobViewBase,
  mixins: [LoadsImages],
  props: {
    partId: {
      type: Number,
      required: true,
    },
  },
  components: {
    QrcodeVue,
  },
  data() {
    return {
      step: 1,
      forceRecomputeCounter: 0,
      reportData: {
        pictures: [],
        checks: {},
        requiredPicture: {},
      },
      codeData: {
        code: null,
        image: null,
      },
      checksAreaIndex: 0,
      checksData: {
        done: [],
        ok: [],
        messages: [],
      },
      changed: false,
      sameCode: false
    };
  },
  computed: {
    part() {
      return this.job ? this.job.parts.find((p) => p.id == this.partId) : null;
    },
    report() {
      return this.part && this.part.report ? this.part.report : this.reportData;
    },
    allowEdit() {
      return (
        this.job && this.job.status == this.app.options.Job.STATUS.inprocess
      );
    },
    requiredPictures() {
      return [];
    },
    pictures() {
      const pictureSources = Array.isArray(this.report.pictures)
        ? this.report.pictures.slice(0)
        : this.report.pictures.files.slice(0);
      const pictures = [];

      for (let i = 0; i < pictureSources.length; i++) {
        const picture =
          pictureSources[i] != null ? this.loadImage(pictureSources[i]) : {};

        if (i < this.requiredPictures.length) {
          Object.assign(picture, this.requiredPictures[i]);
        }

        pictures.push(picture);
      }

      if (pictures.length < this.requiredPictures.length) {
        for (let i = pictures.length; i < this.requiredPictures.length; i++) {
          pictures.push(this.requiredPictures[i]);
        }
      }

      return pictures;
    },
    savedPictures() {
      return this.report.pictures.filter((p) => p != null);
    },
    code() {
      const code =
        this.part && this.part.codes.length
          ? this.part.codes[this.part.codes.length - 1]
          : this.codeData;

      if (code && code.image && (!("src" in code.image) || !code.image.src)) {
        // code.image = this.loadImage(code.image);
        code.code = this.part.codes[this.part.codes.length - 1].code;
      }

      return code;
    },
    checklists() {
      return this.part
        ? this.app.options.Checklists.filter(
            (c) => this.part.checklists.findIndex((p) => p == c.id) != -1
          )
        : [];
    },
    checks() {
      return this.checklists.reduce(
        (checks, checklist) => checks.concat(checklist.checks),
        []
      );
    },
    areas() {
      let obj = {};
      let areas = Object.entries(this.app.options.JobPart.AREAS.door).filter(
        ([key, id]) => {
          return (
            this.checklists.findIndex((c) => {
              return c.part_area == id;
            }) != -1
          );
        }
      );

      this.reportData.requiredPicture = [];
      areas.forEach((y) => {
        if (y.length > 1) {
          obj[y[0]] = [];
          this.reportData.requiredPicture[y[0]] = [];
          this.checklists.forEach((x) => {
            if (x.part_area == y[1]) {
              this.reportData.requiredPicture[y[0]] =
                this.reportData.requiredPicture[y[0]].concat(
                  this.reversInObject(
                    x.images_required ? x.images_required : []
                  )
                );
              if (
                this.report.images &&
                y[0] in this.report.images &&
                this.report.images[y[0]].length > 0
              ) {
                obj[y[0]] = this.report.images[y[0]];
              } else {
                if (x.images_required && x.images_required.length > 0) {
                  obj[y[0]] = obj[y[0]].concat(
                    this.reversInObject(x.images_required, y[0])
                  );
                }
              }
            }
          });
        }
      });

      let filterObj = {};
      areas = areas.map(([key, id]) => {
        filterObj[key] = obj[key];
        return {
          id,
          key,
          images_required: obj[key],
        };
      });
      this.report.images = filterObj;

      return areas;
    },
    checksArea() {
      return this.areas[this.checksAreaIndex];
    },
    picturesArea() {
      this.forceRecomputeCounter;
      let images = this.report.images[this.areas[this.checksAreaIndex].key];
      const pictureSources = Array.isArray(images)
        ? images.slice(0)
        : images.files.slice(0);
      const pictures = [];
      for (let i = 0; i < pictureSources.length; i++) {
        const picture =
          pictureSources[i] != null &&
          (pictureSources[i] instanceof File ||
            "path" in pictureSources[i] ||
            "src" in pictureSources[i])
            ? this.loadImage(pictureSources[i])
            : pictureSources[i];

        if (
          i <
          this.reportData.requiredPicture[this.areas[this.checksAreaIndex].key]
            .length
        ) {
          Object.assign(
            picture,
            this.reportData.requiredPicture[
              this.areas[this.checksAreaIndex].key
            ][i]
          );
          this.report.images[this.areas[this.checksAreaIndex].key][i] = picture;
        }

        pictures.push(picture);
      }

      return pictures;
    },
    areaChecks() {
      let areaChechk = this.checklists
        .filter((c) => c.part_area == this.checksArea.id)
        .reduce((checks, checklist) => checks.concat(checklist.checks), []);
      return areaChechk;
    },
    areaChecksDone() {
      const areaChecksDone = {};

      for (const area of this.areas) {
        const areaChecks = this.checklists
          .filter((c) => c.part_area == area.id)
          .reduce((checks, checklist) => checks.concat(checklist.checks), []);

        areaChecksDone[area.id] = this.ifChecksDone(areaChecks, true)
          ? true
          : areaChecks.some((check) => this.ifCheckHasMessage(check))
          ? 1
          : false;
      }

      return areaChecksDone;
    },
    areaImageDone() {
      this.forceRecomputeCounter;

      const areaChecksDone = {};
      for (const area of this.areas) {
        areaChecksDone[area.id] = this.checkImageAreFill(
          this.report.images,
          area.key
        );
      }

      return areaChecksDone;
    },
    checkImage() {
      this.forceRecomputeCounter;

      let images = this.report.images;
      const result = this.checkImageAreFill(images);
      return result;
    },
    checksDone() {
      return this.ifChecksDone(this.checks);
    },
  },
  watch: {
    part: {
      immediate: true,
      handler(newPart) {
        if (newPart) {
          const report = newPart.report ? newPart.report : null;
          const checksReportData = report ? report.checks : {};

          const checklists = this.app.options.Checklists.filter(
            (c) => newPart.checklists.findIndex((p) => p == c.id) != -1
          );
          const checks = this.checklists.reduce(
            (checks, checklist) => checks.concat(checklist.checks),
            []
          );

          for (const check of checks) {
            const checkData =
              check.id in checksReportData ? checksReportData[check.id] : {};

            if (!("message" in checkData)) {
              Vue.set(checkData, "message", null);
            }

            Object.keys(check.operations).forEach((key) => {
              if (check.operations[key] == 1 && !(key in checkData)) {
                Vue.set(checkData, key, 0);
              }
            });

            if (!(check.id in checksReportData)) {
              Vue.set(checksReportData, check.id, checkData);
            }
          }

          if (!report) {
            Vue.set(this.reportData, "checks", checksReportData);
          }
        }
      },
    },
    pictures(newPictures, oldPictures) {
      const removedPictures = oldPictures.filter(
        (p) => !newPictures.some((q) => q.url == p.url)
      );

      this.unloadImages(removedPictures);
    },
  },
  beforeDestroy() {
    // if (this.changed && this.checkImageAreFill(this.report.images)) {
    //    this.save();
    // }
  },
  methods: {
    checkImageAreFill(item, areakey = null) {
      let result = true;
      if (item) {
        if (areakey) {
          item[areakey].forEach((x) => {
            if (!(x && (x instanceof File || "path" in x || "src" in x))) {
              result = false;
              return false;
            }
          });
        } else {
          Object.keys(item).forEach((key) => {
            item[key].forEach((x) => {
              if (!(x && (x instanceof File || "path" in x || "src" in x))) {
                result = false;
                return false;
              }
            });
          });
        }
      }
      return result;
    },
    reversInObject(item, key = null) {
      let res = [];
      item.forEach((element) => {
        res.push({ label: element });
      });
      return res;
    },
    addPicture(triggerEvent) {
      if (Array.isArray(this.report.pictures)) {
        this.report.pictures.push(...triggerEvent.target.files);
      } else if (
        this.report.pictures &&
        typeof this.report.pictures == "object" &&
        "files" in this.report.pictures
      ) {
        this.report.pictures.files.push(...triggerEvent.target.files);
      }

      this.changed = true;
    },

    addImages(triggerEvent) {
      if (
        Array.isArray(this.report.images[this.areas[this.checksAreaIndex].key])
      ) {
        this.report.images[this.areas[this.checksAreaIndex].key].push(
          ...triggerEvent.target.files
        );
        this.forceRecomputeCounter--;
      } else if (
        this.report.images[this.areas[this.checksAreaIndex].key] &&
        typeof this.report.images[this.areas[this.checksAreaIndex].key] ==
          "object" &&
        "files" in this.report.images[this.areas[this.checksAreaIndex].key]
      ) {
        this.report.images[this.areas[this.checksAreaIndex].key].files.push(
          ...triggerEvent.target.files
        );
        this.forceRecomputeCounter--;
      }

      this.changed = true;
    },
    setImage(index, triggerEvent) {
      if (triggerEvent.target.files.length) {
        if (
          index >
          this.report.images[this.areas[this.checksAreaIndex].key].length
        ) {
          for (let i = 0; i < index; i++) {
            this.report.images[this.areas[this.checksAreaIndex].key].push(null);
          }
        }

        this.report.images[this.areas[this.checksAreaIndex].key].splice(
          index,
          1,
          triggerEvent.target.files[0]
        );
        this.forceRecomputeCounter--;

        this.changed = true;
      }
    },
    setPicture(index, triggerEvent) {
      if (triggerEvent.target.files.length) {
        if (index > this.report.pictures.length) {
          for (let i = 0; i < index; i++) {
            this.report.pictures.push(null);
          }
        }

        this.report.pictures.splice(index, 1, triggerEvent.target.files[0]);
        this.changed = true;
      }
    },
    removeImage(index, triggerEvent) {
      // test
      triggerEvent.preventDefault();
      triggerEvent.stopImmediatePropagation();

      this.app.layout.popups.confirm("Foto wirklich löschen?", (popup) => {
        if (
          index + 1 >
          this.reportData.requiredPicture[this.areas[this.checksAreaIndex].key]
            .length
        ) {
          if (
            Array.isArray(
              this.report.images[this.areas[this.checksAreaIndex].key]
            )
          ) {
            this.unloadImage(
              this.report.images[this.areas[this.checksAreaIndex].key][index]
            );
            this.report.images[this.areas[this.checksAreaIndex].key].splice(
              index,
              1
            );
            this.forceRecomputeCounter++;
          } else if (
            this.report.images[this.areas[this.checksAreaIndex].key] &&
            typeof this.report.images[this.areas[this.checksAreaIndex].key] ==
              "object" &&
            "files" in this.report.images[this.areas[this.checksAreaIndex].key]
          ) {
            this.unloadImage(
              this.report.images[this.areas[this.checksAreaIndex].key].files[
                index
              ]
            );
            this.report.images[
              this.areas[this.checksAreaIndex].key
            ].files.splice(index, 1);
            this.forceRecomputeCounter++;
          }
        } else {
          let obj = {
            label:
              this.reportData.requiredPicture[
                this.areas[this.checksAreaIndex].key
              ].length > index
                ? this.reportData.requiredPicture[
                    this.areas[this.checksAreaIndex].key
                  ][index]
                : "",
          };
          if (
            Array.isArray(
              this.report.images[this.areas[this.checksAreaIndex].key]
            )
          ) {
            this.unloadImage(
              this.report.images[this.areas[this.checksAreaIndex].key][index]
            );

            this.report.images[this.areas[this.checksAreaIndex].key][index] =
              obj;
            this.forceRecomputeCounter++;
          } else if (
            this.report.images[this.areas[this.checksAreaIndex].key] &&
            typeof this.report.images[this.areas[this.checksAreaIndex].key] ==
              "object" &&
            "files" in this.report.images[this.areas[this.checksAreaIndex].key]
          ) {
            this.unloadImage(
              this.report.images[this.areas[this.checksAreaIndex].key].files[
                index
              ]
            );
            this.report.images[this.areas[this.checksAreaIndex].key].files[
              index
            ] = obj;
            this.forceRecomputeCounter++;
          }
        }

        this.changed = true;

        popup.close();
      });
    },
    removePicture(index, triggerEvent) {
      triggerEvent.preventDefault();
      triggerEvent.stopImmediatePropagation();

      this.app.layout.popups.confirm("Foto wirklich löschen?", (popup) => {
        if (index < this.requiredPictures.length) {
          if (Array.isArray(this.report.pictures)) {
            this.unloadImage(this.report.pictures[index]);
            this.report.pictures.splice(index, 1, null);
          } else if (
            this.report.pictures &&
            typeof this.report.pictures == "object" &&
            "files" in this.report.pictures
          ) {
            this.unloadImage(this.report.pictures.files[index]);
            this.report.pictures.files.splice(index, 1, null);
          }
        } else {
          if (Array.isArray(this.report.pictures)) {
            this.report.pictures.splice(index, 1);
          } else if (
            this.report.pictures &&
            typeof this.report.pictures == "object" &&
            "files" in this.report.pictures
          ) {
            this.report.pictures.files.splice(index, 1);
          }
        }

        this.changed = true;

        popup.close();
      });
    },
    async scanCode($triggerEvent = null) {
      const result = await this.$windows.showWindow(
        QrScannerWindow,
        {
          job_report: true,
          code_prop: this.code.code,
          part_id: this.part.id
        },
        $triggerEvent ? $triggerEvent.target : null
      );

      if (result) {
        console.log(result)
        this.code.code = result.code;
        this.sameCode = result.sameCode;
        // this.code.image = this.loadImage(result.image);
        this.changed = true;
      }
    },
    toggleCheckOperation(check, operationId) {
      if (this.allowEdit) {
        this.setCheckOperation(
          check,
          operationId,
          this.ifCheckOperationDone(check, operationId) ? 0 : 1
        );
      }
    },
    checkAll() {
      if (this.allowEdit) {
        for (const check of this.areaChecks) {
          Object.keys(check.operations).forEach((operationId) => {
            this.setCheckOperation(check, operationId, 1);
          });
        }
      }
    },
    setCheckOperation(check, operationId, value) {
      if (this.allowEdit) {
        this.addCheck(check);
        this.$set(this.report.checks[check.id], operationId, value);
        this.changed = true;
      }
    },
    addCheck(check) {
      if (!(check.id in this.report.checks)) {
        const operations = {};

        Object.keys(check.operations).forEach((oid) => {
          operations[oid] = 0;
        });

        this.$set(this.report.checks, check.id, operations);
      }
    },
    async createMessage(check, triggerEvent = null) {
      const windowProps = {
        title: check.title,
        allowEdit: this.allowEdit,
      };

      if (this.report.checks[check.id].message) {
        windowProps.message = this.report.checks[check.id].message;
      }

      const result = await this.$windows.showWindow(
        JobTechnicianMessageWindow,
        windowProps,
        triggerEvent ? triggerEvent.target : null
      );
      if (result) {
        result["check_title"] = check.title;
        this.addCheck(check);
        this.report.checks[check.id].message = result;
        await this.save(true);
      }
    },
    ifCheckDone(check, doneSuccessfully = false) {
      const checkData =
        check.id in this.report.checks ? this.report.checks[check.id] : null;

      return (
        checkData &&
        ((!doneSuccessfully && checkData.message != null) ||
          Object.entries(checkData).every(
            ([key, val]) => key == "message" || val == 1
          ))
      );
    },
    ifChecksDone(checks, doneSuccessfully = false) {
      return checks.every((check) => this.ifCheckDone(check, doneSuccessfully));
    },
    ifCheckOperationDone(check, operationId) {
      return (
        check.id in this.report.checks &&
        operationId in this.report.checks[check.id] &&
        this.report.checks[check.id][operationId] == 1
      );
    },
    ifCheckHasMessage(check) {
      return (
        check.id in this.report.checks && this.report.checks[check.id].message
      );
    },
    gotoPartsOverview() {
      return this.$router.push({
        name: "JobParts",
        params: { jobId: this.job.id },
      });
    },
    async save(remote = false, after = null, generatePdf = null) {
      this.unloadImages();

      if (!this.allowEdit) {
        if (after) {
          after();
        }

        return false;
      }

      const updateData = {
        id: this.job.id,
        parts: [{ id: this.part.id }],
      };

      const report = this.report;
      let images = {};

      if (
        this.savedPictures.length >= this.requiredPictures.length &&
        report.images
      ) {
        Object.keys(report.images).forEach((key) => {
          images[key] = [];
          report.images[key].forEach((x) => {
            if (x && (x instanceof File || "path" in x || "src" in x)) {
              images[key].push(x);
            }
          });
        });
      }
      report.images = images;
      // set code
      if (
        this.codeData.code &&
        !this.part.codes.find((c) => c.code === this.codeData.code)
      ) {
        this.part.codes.push(this.codeData);
      }
      if (this.code && this.code.code) {
        updateData.parts[0].codes = [this.code];
      }

      // set report primary keys
      report.job_id = this.job.id;
      report.part_id = this.part.id;

      // set report status
      report.status = this.ifChecksDone(this.checks, true) ? 1 : 0;
      report.generate_pdf = generatePdf;

      // add report to update data
      updateData.parts[0].report = report;

      // add report to part if there wasn't one yet
      if (!this.part.report) {
        this.part.report = report;
      }

      // save

      this.app.isLoading = true;
      if (navigator.onLine) {
        this.changed = false;
      } else {
        setTimeout(() => {
          this.app.isLoading = false;

          let job_id = this.job.id;
          let paramId = this.part.id;

          const reportRoute = {
            name: "JobParts",
            params: { jobId: job_id, loadJobFromApi: true },
            query: paramId,
          };
          if (!remote) {
            this.$router.push(reportRoute);
          }
        }, 600);
      }

      const overrideKey = "report" + this.part.id;

      this.$store.dispatch("jobs/addOverride", {
        data: updateData,
        key: overrideKey,
      });
      this.$store.dispatch("jobs/commit");

      const updateRemoteTask = this.$store.dispatch(
        "jobs/updateRemote",
        updateData
      );

      if (navigator.onLine) {
        updateRemoteTask.thenAlways([
          "store",
          "dispatch:jobs/deleteOverride",
          { id: this.job.id, key: overrideKey },
        ]);
      }
      if (!updateRemoteTask.isDeffered) {
        await updateRemoteTask;
      }
      this.app.isLoading = false;

      if (after) {
        after();
      }
    },
  },
};
</script>

<style lang="scss">
.job-report {
  .collapsible--closed:hover > .collapsible__head:not(.no-hover),
  .collapsible--open > .collapsible__head:not(.no-hover) {
    background-color: white;
  }
  .collapsible--open
    > .collapsible__head
    > .collapsible__buttons
    > .collapsible__btn-toggle {
    margin-top: -10px;
  }
  .hide-collapse-btn {
    .collapsible__buttons {
      display: none;
    }
  }
  .checklist-collapsible {
    background: white;
    border-radius: 6px;
    overflow: auto;
    margin-bottom: 1rem;
    .no-img {
      background-color: #f8f9fa;
      padding: 2rem;
      display: inline-block;
      margin: 0.5rem;
    }
    .collapsible__body__inner {
      padding: 0 1rem;
      overflow: auto;
      height: inherit;
    }
    .title {
      padding: 1rem 0;
      h2 {
        margin: 0;
        font-size: 1rem;
        line-height: unset;
        font-weight: 600;
        color: #111;
      }
    }
    .collapsible__head__inner {
      margin-right: 2rem !important;
    }

    .collapsible__buttons {
      visibility: initial;
      position: absolute;
      top: 20px;
      width: 20px;
      right: 10px;

      .collapsible__btn-toggle::after {
        animation: none;
        height: 15px;
        content: "";
        background-image: url("~smartdoors-shared/img/icons/chevron-down.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        margin-top: -10px;
        opacity: 0.5;
      }
    }
  }

  .disable-remove {
    opacity: 0.7;
    pointer-events: none;
  }
  display: flex;
  flex-direction: column;

  .tab-container {
    &__body {
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;
    }
  }

  .info-text {
    max-width: 440px;
    margin: auto;
  }

  &__steps {
    &__nav {
      width: auto;
      max-width: 100%;
      margin: auto;

      .tab-container__nav__item {
        // width: 33.33% !important;
        min-width: 250px;
      }
    }
  }

  &__main {
    flex: 1 0 auto;
    padding-bottom: map-get($spacers, xxxl) + map-get($spacers, md);
  }

  &__buttons {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: map-get($spacers, md) map-get($spacers, md);
    z-index: 9;
    display: flex;
    justify-content: space-between;
    background-color: $bg-light;

    .btn:not(:first-child) {
      margin-left: map-get($spacers, md);
    }
  }

  &__pictures {
    justify-content: center;

    &__picture {
      position: relative;
      width: 170px;
      border: 1px solid $black;
      margin-bottom: map-get($spacers, xxxl);

      &__label {
        .picture {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .btn {
          position: absolute;
          left: 0;
          right: 0;
          top: calc(100% + #{map-get($spacers, sm)});
        }
      }

      &__label,
      &__add {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        height: 100%;

        input {
          opacity: 0;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          pointer-events: none;
        }
      }

      &__add {
        .icon-add {
          transform: rotate(45deg);
          width: 24px;
          height: 24px;
        }
        /* For iPad Pro layouts */
        @media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
          .icon-add {
            width: 34px;
            height: 34px;
          }
        }
      }

      &__btn-remove {
        position: absolute;
        right: 0;
        top: 0;
        background-color: $white;
        width: 38px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    > li {
      height: 220px;
      /* For iPad Pro layouts */
      @media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
        button {
          width: 50px;
          height: 50px;
          img {
            width: 30px;
          }
        }
      }
    }
  }

  &__code {
    &__preview-wrapper {
      width: 170px;
      margin: auto;
    }

    &__preview {
      position: relative;
      width: 100%;
      height: 170px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid $black;

      .image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__ok {
      position: absolute;
      left: 100%;
      margin-left: map-get($spacers, mdlg);
      top: 50%;
      width: 25px;
      transform: translateY(-50%);
    }
    .qrcode-ml {
      margin-left: -(map-get($spacers, mdlg));
      width: 100%;
    }
  }

  &__checks {
    display: flex;

    &__door {
      flex: 0 0 260px;
      padding-bottom: map-get($spacers, xl);

      &__img {
        position: relative;

        > button {
          position: absolute;
          background-color: $state-hover;
          color: $white;
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          font-weight: map-get($font-weights, bold);
          font-size: map-get($font-sizes, xxl);
          padding: 0 !important;

          &.active {
            background-color: $state-ok;
          }
          &.done:not(.active) {
            background-color: $bg-light;
          }
        }
      }
    }

    &__check {
      &__status {
        min-width: 24px;
      }

      &__title {
        flex: 1 1 0;
      }
    }

    &__checks {
      flex: 1 1 auto;
    }

    &__operations {
      margin-top: map-get($spacers, mdlg);
    }

    &__operation {
      width: 45px;
    }
  }
}
</style>